import { render, staticRenderFns } from "./SizeGroup.vue?vue&type=template&id=5a3ce2ca"
import script from "./SizeGroup.vue?vue&type=script&lang=js"
export * from "./SizeGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports